<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oBPrDG/media/FC-9789948769729.jpg?1708992365204" alt="This image is the cover for the book زبد البحر"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">زبد البحر
      </h1>
      <p class="bookDescription body article font2">
        <p>عدتُ خطوة للوراء وكأنَّني أريد أن أريح جسدي، غافلةً تمامًا عن أنَّني على حافَّة جرفٍ هارٍ كاد أن ينهار بي، لولا يدُ جهاد التي امتدَّت وجذبَتني بقوَّة لتنقذني وتُوقِفني قبالته، ليتوَقَّف الزمن وأنا أنظر إلى عيونه التي تحوي نظرة خوفٍ وريبة مِن فَقدي. طالت نظرتنا وكأنَّنا نرى بعضنا لأوَّل مرَّة.. كانت نسائم البحر تداعب شَعري أنا هذه المرَّة، والشمس قرَّرَت أن تختفي لتعطينا بعض الخصوصيَّة، فبدَت السماء مِن خلفنا تحمرُّ خجلًا!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        إسلام نمر الجمل
      </h2>
      
      <p class="authorDescription body article">إسلام نمر الجمل، كاتبة وروائية أردنيَّة مِن أصول فلسطينية، مقيمة في الإمارات.  وُلِدَت وتلقَّت تعليمها الجامعي في الأردن، وقامت بصقل موهبتها بالكتابة مِن خلال دورات مكثَّفة في فن الرواية، وشاركَت في عدَّة مسابقات للأدب على مستوى الدولة.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17ca82b0